import { render, staticRenderFns } from "./ObjectsTable.vue?vue&type=template&id=b44440c6&scoped=true&"
import script from "./ObjectsTable.vue?vue&type=script&lang=js&"
export * from "./ObjectsTable.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsTable.vue?vue&type=style&index=0&id=b44440c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44440c6",
  null
  
)

export default component.exports